export default {
  methods: {
    fullName(userObject) {
      return `${userObject.name} ${userObject.surname}`
    }
  }
}
